import { HttpClient } from '@angular/common/http';
import { ApplicationRef, DoBootstrap, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  TranslateCompiler,
  TranslateLoader,
  TranslateModule,
} from '@ngx-translate/core';
import { KeycloakAngularModule } from 'keycloak-angular';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { httpLoaderFactory } from '../shared/helpers/pruning-translation-loader/pruning-translation-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BootstrapAuthService } from './core/auth/services/bootstrap-auth.service';
import { CoreModule } from './core/core.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    KeycloakAngularModule,
    CoreModule,
    TabViewModule,
    ButtonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler,
      },
    }),
  ],
  entryComponents: [AppComponent],
})
export class AppModule implements DoBootstrap {
  constructor(
    private readonly bootstrapAuth: BootstrapAuthService,
  ) {}

  public ngDoBootstrap(appRef: ApplicationRef): void {
    this.bootstrapAuth.bootstrapWithAuth(appRef, AppComponent);
  }
}
